export default __webpack_public_path__ + "static/media/tree-profile.c1083b15.png";